import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/login/page.tsx");
